import { format } from 'date-fns';
import { saveAs } from 'file-saver';

export const COLABORADORES_EXPORT_CSV_COLUMNS = [
  { header: 'nome', key: 'nome' },
  { header: 'apelido', key: 'apelido' },
  { header: 'cpf', key: 'cpf' },
  { header: 'nascimento', key: 'nascimento' },
  { header: 'rg', key: 'rg' },
  { header: 'rg uf', key: 'rg_uf' },
  { header: 'rg emissao', key: 'rg_emissao' },
  { header: 'rg emissor', key: 'rg_emissor' },
  { header: 'email', key: 'email' },
  { header: 'telefone', key: 'telefone' },
  { header: 'obs', key: 'obs' },
  { header: 'endereco', key: 'endereco' },
  { header: 'funcao', key: 'funcao' },
  { header: 'salario base', key: 'salario_base' },
  { header: 'admissao', key: 'admissao' },
  { header: 'demissao', key: 'demissao' },
  { header: 'carteira de trabalho', key: 'carteira_trabalho' },
  { header: 'pis pasep', key: 'pis_pasep' },
  { header: 'valor hora', key: 'valor_hora' },
  { header: 'valor dia', key: 'valor_dia' },
];

function escapeCsvCell(value) {
  if (value == null || value === '') return '';
  const text = String(value);
  if (/[",;\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

export function normalizarLinhasExportColaboradores(response) {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.content)) return response.content;
  if (Array.isArray(response?.data)) return response.data;
  return [];
}

export function montarParametrosExportColaboradores(listFilter) {
  if (!listFilter) {
    return { situacao: 'ATIVO' };
  }
  const {
    page: _page,
    pageSize: _pageSize,
    reduced: _reduced,
    ...filtros
  } = listFilter;
  return filtros;
}

export function downloadColaboradoresCsvArquivo(rows) {
  const headerLine = COLABORADORES_EXPORT_CSV_COLUMNS.map((c) => c.header).join(
    ';',
  );
  const bodyLines = rows.map((row) =>
    COLABORADORES_EXPORT_CSV_COLUMNS.map((col) =>
      escapeCsvCell(row[col.key]),
    ).join(';'),
  );
  const csv = `\uFEFF${[headerLine, ...bodyLines].join('\r\n')}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const fileName = `colaboradores-${format(new Date(), 'dd-MM-yyyy-HH-mm')}.csv`;
  saveAs(blob, fileName);
}
